<template>
  <v-list-tile-action>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-chip v-on="on" :color="opaque ? 'grey' : color" :text-color="textColor">
          <v-avatar>
            <v-icon>{{icon}}</v-icon>
          </v-avatar>
          <span>{{stat}}</span>
        </v-chip>
      </template>
      <span>{{description}}</span>
    </v-tooltip>
  </v-list-tile-action>
</template>

<script>
export default {
  props: {
    /* The color of the chip */
    color: {
      type: String,
      required: true
    },
    /* The description to show on hover */
    description: {
      type: String,
      required: true
    },
    /* The icon to show in the chip */
    icon: {
      type: String,
      required: true
    },
    /* Show the stat with a grey color */
    opaque: {
      type: Boolean
    },
    /* The stat to show, could be a number, a word, what you want */
    stat: {
      required: true
    },
    /* The color of the text inside the chip */
    textColor: {
      type: String,
      default: "white"
    }
  }
};
</script>